import { getNonApiUri } from '../utils/getUri';

export default {
    statusMapImages: {
        dfwTerminal: getNonApiUri('Images/DfwMapTerminal.png'),
        gtaaTerminal: getNonApiUri('Images/GtaaMapTerminal.png'),
        sfoTerminal: getNonApiUri('Images/SfoMapTerminal.png'),
        gtaaSector: getNonApiUri('Images/GtaaMapSector.png'),
        jfkSector: getNonApiUri('Images/JfkT4MapSector.png'),
        dubSector: getNonApiUri('Images/DubMapTerminal.png'),
        laxTerminal: getNonApiUri('Images/LaxMapTerminal.png'),
    },
    smartsuiteLogo: getNonApiUri(
        'Common/Images/Brand/SmartSuite Logo Full Colour.svg'
    ),
    brockLogo: getNonApiUri(
        'Common/Images/Brand/logo_BrockSolutions_FullColour.svg'
    ),
};
